import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { REGISTRATION_WITH_IDIN_ACTION_TYPE } from "./registration-with-idin.action";
import { RegistrationWithIdinState } from "./registration-with-idin.model";

const INITIAL_STATE: RegistrationWithIdinState = {
	getIdinEndpointUrlSuccess: undefined,
	idinEndpointUrl: undefined,
};

export function registrationWithIdinReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): RegistrationWithIdinState {
	switch (action.type) {
		case REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrl: {
			return updateState(state, {
				getIdinEndpointUrlSuccess: undefined,
				idinEndpointUrl: undefined,
			});
		}

		case REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrlSuccess: {
			return updateState(state, {
				getIdinEndpointUrlSuccess: true,
				idinEndpointUrl: action.payload,
			});
		}

		case REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrlFail: {
			return updateState(state, {
				getIdinEndpointUrlSuccess: true,
				idinEndpointUrl: undefined,
			});
		}

		default:
			return state;
	}
}
